export default __webpack_public_path__ + "static/media/Icon_Grid_Selected.65c009b6.svg";